import { shortFilms } from "@/mocks/home";

export default function ShortFilmStrip() {
  return (
    <section id="shorts" className="border-b border-background-200/70 bg-background-50">
      <div className="px-4 py-12 md:px-10 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
              <i className="ri-film-line text-base"></i>
              SHORT FILMS
            </div>
            <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
              短片精选 · 十分钟左右看完
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              节奏更紧凑的短片单元，适合通勤或休息间隙快速进入状态。
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="上一组"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              type="button"
              aria-label="下一组"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div className="no-scrollbar mt-8 flex snap-x gap-5 overflow-x-auto pb-2">
          {shortFilms.map((film) => (
            <article
              key={film.id}
              className="group w-64 shrink-0 snap-start overflow-hidden rounded-lg border border-background-200/80 bg-background-100/50"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={film.cover}
                  alt={`${film.title} 短片`}
                  title={`${film.title} 迷人的保姆短片`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-medium text-background-50">
                  {film.minutes}
                </span>
                <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                  <i className="ri-play-fill text-base"></i>
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950">
                  {film.title}
                </h3>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {film.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-background-200 px-2.5 py-0.5 text-[11px] text-foreground-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}